<template>
    <div>
        <v-icon small color="blue" class="mr-2" @click="href = 'V://calidad/protocolos/PDF/3511.pdf'">
            mdi-eye
        </v-icon>
        <v-icon href="file:///V://calidad/protocolos/PDF/3511.pdf" download>Abrir PDF</v-icon>
        <iframe :src="pdfUrl" width="100%" height="600px"></iframe>
    </div>

</template>

<script>
export default {
    data() {
        return {
            pdfUrl: "V://calidad/protocolos/PDF/3511.pdf"
        };
    }
};
</script>